import { Link } from 'react-router-dom';
import { PortalShell } from '@/layouts/PortalShell/PortalShell';
import { FooterChrome } from '@/layouts/FooterChrome/FooterChrome';
import { nb } from '@/i18n/nb';
import s from './NotFound.module.css';

export function NotFound() {
  return (
    <PortalShell>
      <main className={s.page}>
        <h1 className={s.heading}>404</h1>
        <p className={s.body}>{nb.errors.notFound}</p>
        <Link to="/" className={s.cta}>
          {nb.errors.notFoundCta}
        </Link>
      </main>
      <FooterChrome />
    </PortalShell>
  );
}
